export default { 
    CLIENT: 1,
    PROFESSIONAL: 2,
    COMPANY: 3,
}